// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2SMVu","header":"ReportDetails_header__38igs","title":"ReportDetails_title__3--96","left":"ReportDetails_left__25eQo"};